<template> 
  <div style="position:relative;">
    <section class="itinerario-poster" ref="sectionRef">

      <!-- 🌿 ORNAMENTOS DECORATIVOS EN EL CONTENEDOR PRINCIPAL -->
      <img src="@/assets/decor.png" class="decor-corner decor-top-r" alt="decoración superior derecha" />
      <img src="@/assets/decor.png" class="decor-corner decor-bottom-r" alt="decoración inferior derecha" />

      <h2 class="poster-title">Itinerario</h2>

      <!-- ✨ Separador elegante animado con GSAP/CSS -->
      <div class="separador-elegante-animado" ref="separadorRef"></div>

      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>

      <!-- 🏊‍♂️ TARJETA POOL PARTY -->
      <div class="pool-party-card" ref="poolRef">
        
        <!-- Capa de contenido -->
        <div class="pool-card-inner">

          <!-- PARTE SUPERIOR: Logo 15 estricto a la izquierda | Texto a la derecha -->
          <div class="pool-header-grid">
            <div class="pool-left-col">
              <img src="@/assets/144.png" class="pool-logo-15" alt="15 Años" />
            </div>

            <div class="pool-right-col">
              <h3 class="pool-titulo-continuas">¡La fiesta continúa!</h3>
              <p class="pool-bajada">
                Después de los XV, te esperamos para disfrutar juntos de un Pool Party.
              </p>
            </div>
          </div>

          <!-- PARTE CENTRAL: Recuadro con datos de fecha, lugar y hora -->
          <div class="pool-box-detalles">
            <div class="pool-linea-item">
              <i class="far fa-calendar-alt icono-dorado"></i>
              <span>Domingo 11 de octubre</span>
            </div>
            <div class="pool-linea-item">
              <i class="fas fa-map-marker-alt icono-dorado"></i>
              <span class="lugar-destacado">EL CAPRICHO CASINO</span>
            </div>
            <div class="pool-linea-item">
              <i class="far fa-clock icono-dorado"></i>
              <span>12:00 p. m.</span>
            </div>
          </div>

          <!-- PARTE INFERIOR: Pie "¡No faltes!" -->
          <div class="pool-footer-row">
            <span class="ola-decorativa left"></span>
            <span class="pool-no-faltes">¡No faltes!</span>
            <span class="ola-decorativa right"></span>
          </div>

        </div>
      </div>

    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Recepción',
        hora: '4:00 PM',
        icono: require('@/assets/co - copia.png')
      },
      {
        nombre: 'Cena',
        hora: '6:00 PM',
        icono: require('@/assets/c.png')
      },
      {
        nombre: 'Fiesta',
        hora: '7:00 PM - 12:00 AM',
        nota: 'A disfrutar la fiesta!',
        icono: require('@/assets/disc - copia.png')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)
    const separadorRef = ref(null)
    const poolRef = ref(null)

    onMounted(() => {
      // Animación del separador elegante
      if (separadorRef.value) {
        gsap.fromTo(
          separadorRef.value,
          { width: '0%', opacity: 0 },
          {
            width: '120px',
            opacity: 1,
            duration: 1.2,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: separadorRef.value,
              start: 'top 85%',
              toggleActions: 'play none none none'
            }
          }
        )
      }

      // Animación de la tarjeta Pool Party
      if (poolRef.value) {
        gsap.fromTo(
          poolRef.value,
          { opacity: 0, y: 40, scale: 0.95 },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: poolRef.value,
              start: 'top 85%',
              once: true
            }
          }
        )
      }

      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef, separadorRef, poolRef }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,400;1,500&family=Poppins:wght@400;500;600&display=swap');

.itinerario-poster {
  background-color: #f5f0e6;
  margin-top:-10px;
  padding: 60px 16px 80px;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}

/* 🌿 ESQUINAS DECORATIVAS EN CONTENEDOR PRINCIPAL */
.decor-corner {
  position: absolute;
  width: 150px !important;
  height: auto;
  pointer-events: none;
  z-index: 10;
  margin-top:-80px;
  display: block;
}

/* Superior Derecha: decor.png */
.decor-top-r {
  top: 0;
  left: 0;
}

/* Inferior Derecha: decor2.png Volteado X e Y */
.decor-bottom-r {
  bottom: 0;
  right: -50px;
  transform: scale(-1); /* Voltea en X y en Y simultáneamente */
  /* Alternativa equivalente: transform: scaleX(-1) scaleY(-1); */
}

.poster-title {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 38px;
  letter-spacing: 2px;
  color: #4979a0;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 15px;
}

/* ✨ Separador elegante animado */
.separador-elegante-animado {
  height: 2px;
  margin: 0 auto 50px auto;
  background: linear-gradient(90deg, transparent, #cba56b, #ffffff, #cba56b, transparent);
  background-size: 200% auto;
  animation: brilloSeparador 4s linear infinite;
}

@keyframes brilloSeparador {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 100px;
  height: auto;
  margin-bottom: 12px;
  filter: brightness(0) saturate(100%) invert(48%) sepia(21%) saturate(986%) hue-rotate(167deg) brightness(92%) contrast(87%);
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #383838;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
  font-weight: 600;
  color: #4979a0;
}

.evento-hora {
  display: block;
  font-size: 18px;
  font-style: italic;
  margin-top: 4px;
  color: #555555;
}

.evento-nota {
  display: block;
  font-size: 14px;
  color: #cba56b;
  margin-top: 4px;
  font-family: 'Poppins', sans-serif;
}

/* =========================================================
   🏊‍♂️ TARJETA POOL PARTY - COMPOSICIÓN
========================================================= */
.pool-party-card {
  position: relative;
  margin: 60px auto 0;
  max-width: 520px;
  border-radius: 24px;
  overflow: hidden;
  background-color: #fbf7f0;
  border: 1.5px solid #cba56b;
  box-shadow: 0 10px 30px rgba(73, 121, 160, 0.12);
  box-sizing: border-box;
}

.pool-card-inner {
  position: relative;
  z-index: 3;
  padding: 32px 20px 28px;
  box-sizing: border-box;
}

/* GRID SUPERIOR: EL 15 PERMANECE SIEMPRE A UN LADO */
.pool-header-grid {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 20px;
}

.pool-left-col {
  flex: 0 0 100px;
  text-align: center;
}

.pool-logo-15 {
  width: 100px;
  height: auto;
  display: block;
  filter: drop-shadow(0 4px 8px rgba(73, 121, 160, 0.15));
}

.pool-right-col {
  flex: 1;
  text-align: left;
}

.pool-titulo-continuas {
  font-family: 'Playfair Display', serif;
  font-size: clamp(20px, 4.5vw, 27px);
  font-weight: 700;
  color: #4979a0;
  margin: 0 0 6px 0;
  line-height: 1.15;
  letter-spacing: 0.5px;
}

.pool-bajada {
  font-family: 'Playfair Display', serif;
  font-size: clamp(12px, 2.8vw, 14px);
  color: #444444;
  margin: 0;
  line-height: 1.45;
  font-weight: 400;
}

/* RECUADRO CENTRAL */
.pool-box-detalles {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(73, 121, 160, 0.3);
  border-radius: 16px;
  padding: 14px 20px;
  margin: 0 auto 20px auto;
  max-width: 380px;
  text-align: left;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.pool-linea-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  color: #333333;
  margin: 6px 0;
  font-weight: 500;
}

.icono-dorado {
  color: #cba56b;
  font-size: 15px;
  width: 18px;
  text-align: center;
}

.lugar-destacado {
  color: #4979a0;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* PIE "¡NO FALTES!" */
.pool-footer-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.pool-no-faltes {
  font-family: 'Playfair Display', serif;
  font-size: 24px;
  font-weight: 700;
  color: #4979a0;
  font-style: italic;
  letter-spacing: 1px;
}

.ola-decorativa {
  display: inline-block;
  width: 28px;
  height: 2px;
  background: #5c8ba6;
  position: relative;
}

@media (max-width: 480px) {
  .decor-corner {
    width: 60px;
  }

  .pool-card-inner {
    padding: 26px 14px 22px;
  }

  .pool-left-col {
    flex: 0 0 80px;
  }

  .pool-logo-15 {
    width: 80px;
  }
}
</style>